<template>
  <div>
    <div>
      <h6 class="text-base inline-block">Details</h6>
    </div>

    <ValidationProvider rules="required" name="issueData" tag="div" class="mt-8 w-64">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Issue Date * </BaseFormLabel>
          <BaseFormInput v-model="computedIssueDate" type="date" :disabled="disabled" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider rules="required" name="accountUuid" tag="div" class="mt-8">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Issuer Account * </BaseFormLabel>
          <VSelect
            v-model="computedAccountUuid"
            :options="issuerOptions"
            :reduce="(issuer) => issuer.value"
            :disabled="disabled"
            class="vue-select w-64"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider rules="required" name="accountRelationUuid" tag="div" class="w-1/2 mt-8">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel> Client * </BaseFormLabel>
          <VSelect
            v-model="computedAccountRelationUuid"
            :options="accountRelationOptions"
            :reduce="(accountRelation) => accountRelation.value"
            :disabled="disabled"
            class="vue-select"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="notes" tag="div" class="w-1/2 mt-8">
      <template>
        <BaseFormGroup>
          <BaseFormLabel> Notes </BaseFormLabel>
          <div class="block my-2">
            <VDropdown>
              <template #button="buttonProps">
                <BaseButton
                  type="button"
                  primary
                  outline
                  :disabled="disabled"
                  @click="buttonProps.open"
                >
                  Account Payment Account
                </BaseButton>
              </template>

              <template #default="defaultProps">
                <VDropdownMenu>
                  <a
                    v-for="option in accountPaymentAccountOptions"
                    :key="option.value"
                    role="button"
                    :class="[
                      'block',
                      'px-4',
                      'py-2',
                      'hover:bg-gray-200',
                      'transition-color',
                      'transition-fast',
                      'text-right',
                      'text-sm',
                    ]"
                    @click="defaultProps.close(() => updateNotes(option.value))"
                    >{{ option.label }}</a
                  >
                </VDropdownMenu>
              </template>
            </VDropdown>
          </div>
          <BaseFormTextarea v-model="computedNotes" :disabled="disabled" />
        </BaseFormGroup>
      </template>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

export default {
  components: {
    ValidationProvider,
    VDropdown,
    VDropdownMenu,
  },

  props: {
    issueDate: {
      type: String,
      default: '',
    },
    accountUuid: {
      type: String,
      default: '',
    },
    accountRelationUuid: {
      type: String,
      default: '',
    },
    notes: {
      type: String,
      default: '',
    },
    issuerOptions: {
      type: Array,
      default: () => [],
    },
    accountRelationOptions: {
      type: Array,
      default: () => [],
    },
    accountPaymentAccountOptions: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      //
    };
  },

  computed: {
    computedIssueDate: {
      get() {
        return this.issueDate;
      },
      set(value) {
        this.$emit('update:issue-date', value);
      },
    },

    computedAccountUuid: {
      get() {
        return this.accountUuid;
      },
      set(value) {
        this.$emit('update:account-uuid', value);
      },
    },

    computedAccountRelationUuid: {
      get() {
        return this.accountRelationUuid;
      },
      set(value) {
        this.$emit('update:account-relation-uuid', value);
      },
    },

    computedNotes: {
      get() {
        return this.notes;
      },
      set(value) {
        this.$emit('update:notes', value);
      },
    },
  },

  methods: {
    updateNotes(value) {
      this.computedNotes = value;
    },
  },
};
</script>
